export default "__VITE_ASSET__BQo8GOKv__"